import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithReauth } from 'utils/baseQueryWithReauth';

export const dishordersApi = createApi({
  reducerPath: 'dishorders',
  baseQuery: createBaseQueryWithReauth('/dish-orders'),
  tagTypes: ['DishOrders'],

  endpoints: builder => ({

    // 🔹 GET /dish-orders?page=
    getDishOrders: builder.query({
     query: ({ page = 1, keyword = '' } = {}) => {

        const params = {
          page, // додаємо параметр page до запиту
          keyword
        };
        return {
          url: '',
          method: 'GET',
          params,
        };
      },
      transformResponse: (response, meta) => {
        const pagination = {
          currentPage: meta.response.headers.get('x-pagination-current-page'),
          pageCount: meta.response.headers.get('x-pagination-page-count'),
          perPage: meta.response.headers.get('x-pagination-per-page'),
          totalCount: meta.response.headers.get('x-pagination-total-count'),
        };
       return { data: response, pagination };
      },
      providesTags: ['DishOrders'],
       refetchOnReconnect: true,
      refetchOnMountOrArgChange: true,
      refetchOnFocus: true,
      keepUnusedDataFor: 0,
    }),

    // 🔹 POST /dish-orders/view?id=
    getDishOrder: builder.query({
      query: (id) => ({
        url: '/view',
        method: 'GET',
        params: { id },
      }),
      providesTags: ['DishOrders'],
    }),

    // 🔹 POST /dish-orders/cancel?id=
    cancelDishOrder: builder.mutation({
      query: (id) => ({
        url: '/cancel',
        method: 'POST',
        params: { id },
      }),
      invalidatesTags: ['DishOrders'],
    }),

    // 🔹 POST /dish-orders/report-done?orderId=&dishId=
    reportDishDone: builder.mutation({
      query: ({ orderId, dishId }) => ({
        url: '/report-done',
        method: 'POST',
        params: { orderId, dishId },
      }),
      invalidatesTags: ['DishOrders'],
    }),

    // 🔹 POST /dish-orders/confirm-return?id=
    confirmDishReturn: builder.mutation({
      query: (id) => ({
        url: '/confirm-return',
        method: 'POST',
        params: { id },
      }),
      invalidatesTags: ['DishOrders'],
    }),
   acceptDishReturn: builder.mutation({
      query: (id) => ({
        url: '/accept',
        method: 'POST',
        params: { id },
      }),
      invalidatesTags: ['DishOrders'],
    }),

  }),
});

export const {
  useGetDishOrdersQuery,
  useGetDishOrderQuery,
  useCancelDishOrderMutation,
  useReportDishDoneMutation,
  useConfirmDishReturnMutation,
  useAcceptDishReturnMutation
} = dishordersApi;